import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';

import { CMSImage } from '@swf/cms';
import type { Menu } from '@swf/core/types/CMS';

import styles from './Logos.scss';

interface Props {
  logos: Menu;
}

const Logos: React.FC<Props> = ({ logos }) => (
  /* eslint-disable react/jsx-no-target-blank */
  <div className={styles.logos}>
    {logos.map(({ rel, href, className, image }, index) => (
      <a
        href={href}
        rel={`${rel} noopener noreferrer`}
        style={
          !image?.asset?.url
            ? { backgroundImage: `url('//s4.rationalcdn.com/img/bg/estate/footer-small.png')` }
            : undefined
        }
        className={classNames(styles.logo, {
          [styles[camelCase(className)]]: className && !image?.asset?.url,
          [styles.imageContainer]: image?.height || image?.width
        })}
        target="_blank"
        key={index}
      >
        {image?.asset?.url && (
          <CMSImage {...image} className={!image?.height ? styles.image : ''} />
        )}
        <span>{className}</span>
      </a>
    ))}
  </div>
  /* eslint-enable */
);

export default Logos;
